<div class="sub-menubar" *ngIf="activeMenu">
  <!-- Loading skeleton - only show when loading matter data -->
  <div *ngIf="isLoading && activeMenu === 'matter'" class="menu-skeleton">
    <p-skeleton width="94px" height="28px" />
    <p-skeleton width="65px" height="28px" />
    <p-skeleton width="70px" height="28px" />
    <p-skeleton width="125px" height="28px" />
    <p-skeleton width="80px" height="28px" />
    <p-skeleton width="70px" height="28px" />
    <p-skeleton width="50px" height="28px" />
    <p-skeleton width="120px" height="28px" />
    <p-skeleton width="96px" height="28px" />
  </div>

  <!-- Actual menu - only show when not loading -->
  <p-menubar
    *ngIf="!isLoading"
    [model]="menuItems"
    styleClass="border-none"
    breakpoint="320px">
  </p-menubar>

  <app-legacy-review
  [entityType]="entityType"
  [entityId]="entityCode"
></app-legacy-review>
</div>
